export default "__VITE_ASSET__navMFirN__"